import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import { ContactInterface } from 'modules/contacts/types/contact-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { BlockedIcon, MutedIcon, StoppedIcon, TimeIcon } from '@systemeio/ui/icons';
const ContactStatus = t0 => {
  const $ = _c(18);
  const {
    contact
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== contact.unsubscribedFromTransactionalEmails || $[1] !== t) {
    t1 = contact.unsubscribedFromTransactionalEmails && <Tooltip mode="hover" label={t("dashboard.contacts.unsubscribed_from_transactional_emails")}><BlockedIcon className="main-transition-colors hover:fill-danger" /></Tooltip>;
    $[0] = contact.unsubscribedFromTransactionalEmails;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== contact.unsubscribed || $[4] !== t) {
    t2 = contact.unsubscribed && <Tooltip mode="hover" label={t("dashboard.contacts.contact_silence")}><MutedIcon className="main-transition-colors hover:fill-danger" /></Tooltip>;
    $[3] = contact.unsubscribed;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== contact.bounceReason || $[7] !== contact.bounced || $[8] !== t) {
    t3 = contact.bounced && contact.bounceReason !== null && <Tooltip mode="hover" label={t("dashboard.contacts.contact_bounce", {
      reason: contact.bounceReason
    })}><StoppedIcon className="main-transition-colors hover:fill-danger" /></Tooltip>;
    $[6] = contact.bounceReason;
    $[7] = contact.bounced;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== contact.needConfirmation || $[11] !== t) {
    t4 = contact.needConfirmation && <Tooltip mode="hover" label={t("dashboard.contacts.not_confirmed")}><TimeIcon className="main-transition-colors hover:fill-danger" /></Tooltip>;
    $[10] = contact.needConfirmation;
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className="flex gap-1.5">{t1}{t2}{t3}{t4}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
};
export default ContactStatus;